<template>
  <v-dialog v-model="modalComputed" persistent="" max-width="550">
    <v-card>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2" class="d-flex justify-center">
              <v-icon size="65" color="primary">mdi-help-circle</v-icon>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="10" lg="10" xl="10">
              {{ texto }}
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed text color="primary" @click="modalComputed=false">FECHAR</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {

  name: 'Ajuda',

  props: {
    texto: {
      required: true,
      type: String
    },
    modal: {
      required: true,
      type: Boolean
    }
  },

  data(){
    return {
      modalTemp: undefined,
      textoTemp: undefined,
    }
  },

  created: function() {
    this.modalComputed = this.modal
    this.textoComputed = this.texto
    this.$emit('callback')
  },

  computed: {
    modalComputed: {
      get: function() {
        return this.modalTemp
      },
      set: function(v) {
        this.modalTemp = v
      }
    },
    textoComputed: {
      get: function() {
        return this.textoTemp
      },
      set: function(v) {
        this.textoTemp = v
      }
    }

  }

}
</script>